import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterMaestroDocumentoModel } from 'src/app/models/interfaces/maestro-documento/IFilterMaestroDocumentoModel';
import { IMaestroDocumentoModel } from 'src/app/models/interfaces/maestro-documento/IMaestroDocumentoModel';
import { FilterMaestroDocumentoModel } from 'src/app/models/maestro-documento/FilterMaestroDocumentoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { MaestroDocumentosService } from 'src/app/services/maestro-documentos/maestro-documentos.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  selector: 'app-maestro-documento-listar',
  templateUrl: './maestro-documento-listar.component.html',
  styleUrls: ['./maestro-documento-listar.component.css']
})
export class MaestroDocumentoListarComponent implements OnInit {

  model!: SearchResultModel<IMaestroDocumentoModel[]>;
  filter: IFilterMaestroDocumentoModel = new FilterMaestroDocumentoModel();
  resultsLength = 0;
  currentPage = 0;

  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  displayedColumns: string[] = [
    'id',
    'documento',
    'idEstado',
    'acciones'
  ];

  @ViewChild('paginator') paginator!: MatPaginator;
  
  constructor(
    private maestroDocumentoService: MaestroDocumentosService,
    private serviceParametros: ParametroService
  ) { 
    
  }
  
  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_DOCUMENTO).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.model = new SearchResultModel<IMaestroDocumentoModel[]>(false, new Array<IMaestroDocumentoModel>(), 0, 1, 0);
    this.search();
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.maestroDocumentoService
      .getListPaged(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.maestroDocumentoService
      .getListPaged(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }  
}
